import { render } from "./privacyAgreementView.vue?vue&type=template&id=907b0e2e&scoped=true"
import script from "./privacyAgreementView.vue?vue&type=script&lang=js"
export * from "./privacyAgreementView.vue?vue&type=script&lang=js"

import "./privacyAgreementView.vue?vue&type=style&index=0&id=907b0e2e&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907b0e2e"]])

export default __exports__